/* eslint-disable no-unused-vars */
/**
 * @file Controle da execução em jogo.
 * jsdoc Board.js ControlLevel.js  Construtor.js ControlGame.js -d ../../documention
 * @author William Luis Alves Ferreira (git:illiamw)
 * @version 2.0.0
 */
import React from "react";
import View_Rank from "./View_Rank";
import ModalFull from "./ViewComponentsNav/ModalFull";
import Modal from "./ViewComponentsNav/Modal";

//Logos
import logo from "./../../Assets/logo-eic-horizontal.svg";
import mais from "./../../Assets/Game-Button-PNG.webp";
import rank from "./../../Assets/rank-Button-PNG.webp";


//Componentes de roteamento
import { Link , Outlet} from "react-router-dom";

/**
 * @param {Null} Null Null
 * @description Classe geradora da função app
 * @constructor
 */

 export default class View_inicial extends React.Component {

  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);

    this.state = {
      tryNick: false
    }

  }

  logout() {
    this.props.auth.auth.signOut()
    console.log("deslogar");
  }

  handleChange(e) {
    this.props.auth.usuario.setNickname(e.target.value)
  }

  atualizarNick() {
    this.props.auth.usuario.updateUsuario()
    this.forceUpdate()
    this.setState({
      tryNick: true
    });
  }

  tela_setnick() {
    return (
      <div className="text-center">
        <h4 className="mb-5">
          Se você prefere um nome de usuário diferente do usado na sua autenticação altere no campo a seguir!
        </h4>

        <input
          type="text"
          placeholder="Máximo 20 caracteres"
          maxLength="20"
          className="p-2 mx-3 bg-white1 arround-6"
          onChange={this.handleChange} />

        <button
          type="button"
          className="button-custom inicial bg-color4 arround-6"
          onClick={() => this.atualizarNick()}
        >
          Atulizar
        </button>

        {this.state.tryNick ? (<p className="pt-2">
          Atualizado com sucesso!
        </p>) : (<p className="pt-2"></p>)}
      </div>
    );
  }
  render() {
  // ROTEAMENTO - colocar controle de estados da aplicação
  return (
    <div id="TESTE" className="col d-flex flex-column align-items-center bg-color1 text-center w-100 h-100 ">
      
      <div className="flex-fill bg-color1 w-100 text-center align-items-start d-flex justify-content-between">
          <div className="d-flex col justify-content-start">
            <a className="mais-jogos" href="https://eic.ifsc.usp.br/category/jogos/">
              <img
                src={mais}
                alt="Mais jogos"
                href="https://eic.ifsc.usp.br/category/jogos/"
                className="img-fluid w-logo"
              />
            </a>

          </div>
          <div className="d-flex col  justify-content-end">
            <div data-bs-toggle="modal" className="mais-jogos"
              data-bs-target="#modal-rank">
              <img
                src={rank}
                alt="Mais jogos"
                href="https://eic.ifsc.usp.br/category/jogos/"
                className="img-fluid w-logo"
              />
            </div>
          </div>
        </div>    
      <div className="flex-grow-1 p-3 d-flex align-items-center">
        <div className="col">
          <a href="http://eic.ifsc.usp.br/">
            <img
              src={logo}
              alt="Logo"
              href="http://eic.ifsc.usp.br/"
              className="img-fluid w-logo"
            />
          </a>
        </div>
      </div>

      <div className="flex-fill bg-color1  p-3 text-center align-items-center">
        <div>
          <h1 className="text-white1 display-1 fw-bold">Cruzadinhas </h1>
          <h2 className="text-color4 display-4 fw-bold">Jardim Medicinal</h2>
        </div>
      </div>

      <div className="flex-shrink-1 bg-color1  p-3 text-center align-items-end">
        <div>
          <Link to="/instrucao-0">
            <button
              type="button"
              className="button-custom inicial bg-color4 arround-6"
              data-bs-toggle="modal"
              data-bs-target="#modal-login"
            >
              INICIAR
            </button>
          </Link>
        </div>
      </div>

      <div className="flex-shrink-1 bg-color1  p-3 text-center align-items-end">
        <div className="bg-color2 p-2 arround-6 text-white1">
            Entrar como: {this.props.auth.usuario.nick} ou {<Link to="/login" className="text-white1" onClick={() => this.logout()}>
              Trocar de Usuário
            </Link>}
          </div>
          <div>
            <div className="mt-2 bg-color2 p-2 arround-6 text-white1">
              Personalizar nick: {
                <a
                  className="text-white1"
                  data-bs-toggle="modal"
                  data-bs-target="#modal-setnick"
                >
                  Alternar
                </a>}
            </div>
          </div>
        </div>

        <div className="flex-shrink-1 w-100 bg-color1 px-3 p-md-0 text-center  d-flex justify-content-between align-items-end">

        <div>
          <Link to="/creditos">
            <i className="material-icons md-light md-48">groups</i>
          </Link>
        </div>
        <div>
          <Link to="/compartilhar">
            <i className="material-icons md-light md-48">share</i>
          </Link>
        </div>
        <Outlet />
      </div>
      <ModalFull vinculo="modal-rank">
          <div className="view1">
            <View_Rank className="flex-fill" serve={this.props.serve} auth={this.props.auth} />
          </div>
        </ModalFull>

        <Modal vinculo="modal-setnick" titulo="Alterar">
          {this.tela_setnick()}
        </Modal>
    </div>
  );
  }
}
